module.exports = __webpack_public_path__ + "e363af5efe88edaf2022d646481aecfb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/NanumGothicBold.ttf
// module id = 592
// module chunks = 0